import { useTranslation } from "react-i18next";
import { css } from "../../../../styled-system/css";
import { Modal } from "../basic/Modal";

type HubspotCalendarModalProps = {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
};

export function HubspotCalendarModal({ isOpen, onOpenChange }: HubspotCalendarModalProps) {
  const { t } = useTranslation(["hubspot"]);
  return (
    <Modal isOpen={isOpen} onOpenChange={onOpenChange} title={t(($) => $.hubspot["Book a Demo"])}>
      <div className={css({ display: "flex", justifyContent: "center", paddingX: "large" })}>
        {/* eslint-disable-next-line react/iframe-missing-sandbox -- HubSpot requires scripts + same-origin (cookies), which negates sandbox */}
        <iframe
          title={t(($) => $.hubspot["Hubspot Calendar"])}
          height="575"
          width="380"
          className={css({ border: "1px solid", borderColor: "gray.200" })}
          src="https://meetings.hubspot.com/sriteja/discovery-call?embed=true"
        />
      </div>
    </Modal>
  );
}
